
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giveback-2021",
      function () {
        return require("private-next-pages/giveback-2021.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giveback-2021"])
      });
    }
  